import { useTranslate } from '@tolgee/react';
import { memo } from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

const EstimatedAvailableTimeTip = memo(() => {
  const { qaEnable: isEnterpriseEdition } = useOrgConfigStateValue();
  const { t } = useTranslate();
  return (
    <Tooltip
      title={
        isEnterpriseEdition
          ? t('outofstock_table_explanation_enterprise')
          : t('outofstock_table_explanation_non_enterprise')
      }
    >
      <QuestionCircleOutlined className="cursor-pointer" />
    </Tooltip>
  );
});

export default EstimatedAvailableTimeTip;
